import { fetchJSON as fetchAPI } from './client';

export type SprintDashboard = {
  sprint_id: string; objectives: number; operating_modules: number; operating_dimensions: number;
  validation_areas: number; quality_gates: number; generated_at: string;
};

export type SprintValidation = {
  valid: boolean; no_critical_defects: boolean; daily_ops_on_kartmanage: boolean;
  recommendations_trusted: boolean; customer_value_accurate: boolean;
  performance_targets_met: boolean; founder_daily_use: boolean; gaps?: string[];
};

export type Alpha001Status = {
  sprint_id: string; objectives: number; operating_modules: number; validation_areas: number;
  internal_alpha: boolean; founder_testing: boolean; status: string;
};

const GOVERNANCE_BASE = import.meta.env.VITE_GOVERNANCE_API ?? '/api/v1/governance';
const fetchG = <T,>(path: string, init?: RequestInit) => fetchAPI<T>(`${GOVERNANCE_BASE}${path}`, init);

export const internalAlphaAlpha001Api = {
  dashboard: () => fetchG<SprintDashboard>('/alpha001/dashboard'),
  objectives: () => fetchG<{ objectives: { key: string; name: string; category: string }[] }>('/alpha001/objectives').then((r) => r.objectives),
  operatingModules: () => fetchG<{ modules: { key: string; name: string; category: string }[] }>('/alpha001/operating-modules').then((r) => r.modules),
  operatingDimensions: () => fetchG<{ dimensions: { key: string; name: string; category: string }[] }>('/alpha001/operating-dimensions').then((r) => r.dimensions),
  providers: () => fetchG<{ providers: { key: string; name: string; interface: string }[] }>('/alpha001/service-architecture').then((r) => r.providers),
  backgroundJobs: () => fetchG<{ jobs: { key: string; name: string; schedule?: string }[] }>('/alpha001/background-jobs').then((r) => r.jobs),
  qualityGates: () => fetchG<{ gates: { key: string; name: string; blocking: boolean }[] }>('/alpha001/quality-gates').then((r) => r.gates),
  validate: (attrs: Record<string, boolean>) =>
    fetchG<SprintValidation>('/alpha001/validate', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attrs }) }),
  status: () => fetchG<Alpha001Status>('/alpha001/status'),
};
